import { api } from './api.js';

// كاش في الذاكرة: يجعل الرجوع بين الشاشات فورياً بلا إعادة جلب.
// يُبطَل تلقائياً عند أي حدث مزامنة يمسّ المورد.
const store = new Map();          // path -> { data, at }
const inflight = new Map();       // path -> Promise (يمنع الطلبات المكررة المتزامنة)
const TTL = 60_000;

// ?nocache=1 يعطّل الكاش — للقياس والمقارنة فقط
const OFF = typeof location !== 'undefined' && location.search.includes('nocache');

export async function cached(path, { ttl = TTL, force = false } = {}) {
  if (OFF) return api(path);
  const hit = store.get(path);
  if (!force && hit && Date.now() - hit.at < ttl) return hit.data;
  if (inflight.has(path)) return inflight.get(path);
  const p = api(path)
    .then((data) => { store.set(path, { data, at: Date.now() }); return data; })
    .finally(() => inflight.delete(path));
  inflight.set(path, p);
  return p;
}

// أبطِل كل ما يبدأ بهذه البادئات
export function invalidate(...prefixes) {
  for (const key of [...store.keys()]) {
    if (!prefixes.length || prefixes.some((p) => key.startsWith(p))) store.delete(key);
  }
}

export function clearCache() { store.clear(); inflight.clear(); }

// خريطة موارد المزامنة → بادئات المسارات التي يجب إبطالها
const MAP = {
  products: ['/products', '/inventory'],
  inventory: ['/products', '/inventory'],
  customers: ['/customers'],
  sales: ['/sales', '/dashboard', '/reports'],
  dashboard: ['/dashboard'],
  reports: ['/reports', '/collections'],
  pos: ['/products', '/customers', '/held-sales'],
  held: ['/held-sales'],
  employees: ['/users'],
  pricing: ['/quotes'],
  purchases: ['/purchases'],
  suppliers: ['/suppliers'],
  // النفقة تدخل الربح والخسارة، فتغيّرها يُبطل التقارير ولوحة التحكم لا شاشتها وحدها
  expenses: ['/expenses', '/dashboard', '/reports'],
};

export function invalidateFromEvent(event) {
  if (!event) return;
  const resources = event.resources || [];
  if (resources.includes('*')) return clearCache();
  const prefixes = new Set();
  for (const r of resources) (MAP[r] || []).forEach((p) => prefixes.add(p));
  if (prefixes.size) invalidate(...prefixes);
}
